/* global SERVER_URL, $, CAMERAS_URL */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Mousetrap from 'mousetrap';
import { connect } from 'react-redux';
import fetch from 'isomorphic-fetch';
import { modal } from 'react-redux-modal';
import ReactTooltip from 'react-tooltip';
import { animateScroll } from 'react-scroll';
import Cookie from 'js-cookie';
import AxialMap from 'axial-map';
import moment from 'moment';

import { checkHttpStatus, parseJSON, isMobile, hlsStreamLatency } from '../../utils';
import { fetchUserFavorites } from '../../actions/favorites';
import { toggleRelatedSnapshots, changeViewMode } from '../../actions/uiPreferences';
import { generateSnapshotTimeline } from '../../actions/takeSnapshot';
import { setIsLive } from '../../actions/currentItem';
import { SNAPSHOTS, CAROUSEL } from '../../constants/viewmodes';

import {
  LoginModalView,
  TakeSnapshotModal,
  AlertsView,
  RelatedSnapshotsCarousel,
  ComingSoonModal,
  FavoriteButton,
  PlayerAlert,
  SignUpModalView,
  PartnerModalView,
  DownloadAppModalView,
  PopModalView,
  InfoPanelView,
  SocialModalView,
} from '../../components';
import VideoScreen from './VideoScreen';
import RefreshButton from '../Buttons/RefreshButton';

import './style.scss';
import Hls from 'hls.js';
import { fetchAndSetCamerasApiToken } from '../../actions/auth';
import TrackedButton from '../Buttons/TrackedButton';
import BroadcastToFacebookButton from './BroadcastToFacebookButton';
import SendPlayerAlertButton from './SendPlayerAlertButton';
import PopoutCommentsManager from '../PopoutManager/PopoutCommentsManager';
import PopoutVideoManager from '../PopoutManager/PopoutVideoManager';

class VideoPlayer extends React.Component {

  constructor(props) {
    super(props);

    this.takeSnapshot = this.takeSnapshot.bind(this);
    this.postComment = this.postComment.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.ontoggleRelatedSnapshots = this.ontoggleRelatedSnapshots.bind(this);
    this.onComingSoon = this.onComingSoon.bind(this); // Does not appear to be used.
    this.shareFeed = this.shareFeed.bind(this);
    this.refresh = this.refresh.bind(this);
    this.setViewMode = this.setViewMode.bind(this);
    this.openSignup = this.openSignup.bind(this);
    this.openPartner = this.openPartner.bind(this);
    this.openDownloadApp = this.openDownloadApp.bind(this);
    this.openPopModal = this.openPopModal.bind(this);
    this.onToggleInfoOverlay = this.onToggleInfoOverlay.bind(this);
    this.openSocial = this.openSocial.bind(this);
    this.ontoggleRelatedSnapshots = this.ontoggleRelatedSnapshots.bind(this);
    this.startWebsocket = this.startWebsocket.bind(this);
    this.startHls = this.startHls.bind(this);
    this.onSnapshotFailure = this.onSnapshotFailure.bind(this);
    this.startTrackingSnapshots = this.startTrackingSnapshots.bind(this);
    this.snapshotIsEnabled = this.snapshotIsEnabled.bind(this);
    this.isCameraLive = this.isCameraLive.bind(this);
    this.noop = () => {
    };

    this.maxSize = 1024;
    this.wsMaxAttempts = 60; // How many times should we attempt to reconnect.
    this.wsReconnectLatency = 1500; // How many milliseconds between retries.
    this.hls = null;

    this.state = {
      submittingComment: false,
      showVideoCarousel: true,
      key: new Date().getTime(),
      showInfoOverlay: false,
      infoOverlayType: '',
      recordingsTemplate: null,
      websocket: null,
      snapshots: new AxialMap({ maxSize: this.maxSize }),
      snapshotFailure: false,
      wsReconnectAttempts: 0,
    };
  }

  ontoggleRelatedSnapshots(e) {
    e.preventDefault();
    this.props.dispatch(toggleRelatedSnapshots());
  }

  setViewMode(mode) {
    this.props.dispatch(changeViewMode(mode));
  }

  shouldComponentUpdate() {
    return true;
  }

  shareFeed(e, type, message, hashtags) {
    hashtags = hashtags || '';
    e.preventDefault();
    if (type === 'twitter') {
      window.open(`https://twitter.com/share?url=${window.location.href}&amp;text=${message}&amp;hashtags=${hashtags}`, null, 'width=600,height=400');
    } else if (type === 'facebook') {
      window.open(`https://www.facebook.com/sharer.php?u=${window.location.href}`, null, 'width=600,height=400');
    }
  }

  componentWillMount() {
    if (this.props.isAuthenticated && this.props.userId) {
      this.props.dispatch(fetchUserFavorites(this.props.userId));
    }
  }

  componentDidMount() {
    Mousetrap.bind(['command+option+s', 'ctrl+alt+s'], () => this.takeSnapshot());
    const { recordings_template: recordingsTemplate, stream_id: streamId } = this.props.currentItem;
    this.startTrackingSnapshots(recordingsTemplate, streamId);
  }

  componentWillUnmount() {
    Mousetrap.unbind(['command+option+s', 'ctrl+alt+s']);
    if (this.hls) {
      this.hls.stopLoad();
      this.hls = null;
    }
    const { websocket } = this.state;
    if (websocket) {
      websocket.close(1000, 'Changed livecams');
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.cameraToken) {
      console.log('no token set');
      this.props.dispatch(fetchAndSetCamerasApiToken());
    }

    if (this.props.viewMode === SNAPSHOTS && nextProps.viewMode === CAROUSEL) {
      window.requestAnimationFrame(() => {
        const GUTTER = 10;
        const offset = document.querySelector('.video-player')
            .getBoundingClientRect().top
          - document.body.getBoundingClientRect().top
          - document.querySelector('.header-wrapper')
            .getBoundingClientRect().height
          - GUTTER;
        window.scrollTo(0, offset);
      });
    }

    const { id: currentId } = this.props.currentItem;
    const { id: nextId, recordings_template: recordingsTemplate, stream_id: nextStreamId } = nextProps.currentItem;
    if (nextId !== currentId) {
      if (this.hls) {
        this.hls.stopLoad();
        if (!nextStreamId) {
          this.setState({ hlsStream: null });
        }
      }
      const { websocket } = this.state;
      if (websocket) {
        websocket.close(1000, 'Changed livecams');
      }
      this.startTrackingSnapshots(recordingsTemplate, nextStreamId);
    }
  }

  startTrackingSnapshots(recordingsTemplate, streamId) {
    const snapshots = new AxialMap({ maxSize: this.maxSize });
    this.setState({ recordingsTemplate, snapshots }, () => {
      if (this.props.snapshotsEnabledGlobally && streamId) {
        this.startHls(streamId, this.props.cameraToken);
      } else if (this.snapshotIsEnabled()) {
        const websocketUri = `wss://snapdata.prod.explore.org/oldest/${recordingsTemplate}-EDGE`;
        this.startWebsocket(websocketUri);
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.currentItem.id) return;
    if (prevProps.currentItem.id !== this.props.currentItem.id) {
      this.scrollToVideo();
      this.setState({
        showInfoOverlay: false,
        infoOverlayType: '',
        snapshots: new AxialMap({ maxSize: this.maxSize }),
      });
    }
  }

  startWebsocket(uri) {
    const websocket = new WebSocket(uri);
    websocket.onopen = () => {
      // Reset the reconnect attempts if it successfully opens the websocket
      this.setState({ wsReconnectAttempts: 0 });
    };
    websocket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      const { snapshots } = this.state;
      snapshots.add(data.utcTimestamp, data);
      this.setState({ snapshots });
    };
    websocket.onerror = err => console.error(err);
    websocket.onclose = (event) => {
      // 1000 and 1001 event codes mean that the connection was intended to be closed.
      // 1005 indicates it was closed without a specified reason. Otherwise there was an error.
      if (event.code !== 1000 && event.code !== 1001 && event.code !== 1005) {
        const { wsReconnectAttempts } = this.state;
        if (wsReconnectAttempts < this.wsMaxAttempts) {
          setTimeout(() => {
            this.setState({ wsReconnectAttempts: wsReconnectAttempts + 1 });
            this.startWebsocket(uri);
          }, this.wsReconnectLatency);
        } else {
          console.error('Maximum websocket reconnect attempts exceeded.');
        }
      }
    };
    this.setState({ websocket });
  }

  startHls(id, token) {
    const url = `${CAMERAS_URL}/streams.json?q[id_in][]=${id}`;

    fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.json())
      .then(this.onStreamsResponse.bind(this))
      .catch(error => console.log(error));
  }

  onStreamsResponse({ streams }) {
    const { currentItem: { stream_id: streamId } } = this.props;
    if (!streams || streams?.length === 0) return;

    const stream = streams.find(item => item.id === parseInt(streamId, 10));

    if (!stream) return;

    this.setState({ hlsStream: stream }, () => {
      const isLive = this.isCameraLive();
      if (isLive !== this.props.isLive) {
        this.props.dispatch(setIsLive(isLive));
      }
    });

    // TODO Mark live in redux
    const Driver = Hls;
    this.hls = this.hls || new Driver();
    this.hls.on(Driver.Events.LEVEL_LOADED, (_event, data) => {
      const { hlsStream, snapshots } = this.state;
      const fragments = data.details.fragments;

      const lastFragment = fragments.reverse()[3];
      const { baseurl, url } = lastFragment;
      const parsedUrl = new URL(url);

      let snapshotHost = '';
      if (!hlsStream) {
        return;
      }
      if (hlsStream.playlistUrl === baseurl) {
        snapshotHost = hlsStream.snapshotHost;
      }

      parsedUrl.hostname = snapshotHost;
      const matches = parsedUrl.href.match(/(\d{8}T\d{6})/gm);
      if (matches && matches[0]) {
        const timestamp = moment.utc(matches[0]);

        snapshots.add(timestamp.unix(), {
          scaledUri: `${parsedUrl.href}.jpg`,
          uri: `${parsedUrl.href}.jpg`,
          utcTimestamp: timestamp.unix(),
        });
        this.setState({ snapshots });
      }
    });

    this.hls.loadSource(stream.playlistUrl);
  }

  hideOtherCams() {
    return (
      <TrackedButton
        className="toggle-snapshots-carousel b-0 btn btn-link m-0 p-0"
        onClick={this.ontoggleRelatedSnapshots}
        title="Hide Other Cams"
        action="Click on Hide Other Cams"
      />
    );
  }

  showOtherCams() {
    return (
      <TrackedButton
        className="toggle-snapshots-carousel inactive b-0 btn btn-link m-0 p-0"
        onClick={this.ontoggleRelatedSnapshots}
        title="Show Other Cams"
        action="Show Other Cams"
      />
    );
  }

  openSignup(e) {
    e.preventDefault();
    modal.add(SignUpModalView, { title: '', size: 'medium', hideTitleBar: true, id: 'signup' });
  }

  takeSnapshot(asCallback) {
    const { currentItem, currentCamGroup } = this.props;
    const { snapshots } = this.state;
    const isCalledAsCallback = asCallback || false;

    if (currentCamGroup.multi_livecam) {
      return;
    }

    if (!$(this.refs.snapshot)
      .hasClass('offline')) {
      if (!isCalledAsCallback) {
        modal.clear();
      }
      const today = Date.now();
      let timestamp = null;
      if (!currentItem.stream_id) {
        timestamp = parseInt(today.toString()
          .split('')
          .slice(0, 10)
          .join(''), 10) - 15 - 25;
        this.props.dispatch(generateSnapshotTimeline(timestamp, 10, true, snapshots, false));
      } else {
        timestamp = parseInt(today.toString()
          .split('')
          .slice(0, 10)
          .join(''), 10) - hlsStreamLatency;
        this.props.dispatch(generateSnapshotTimeline(timestamp, 10, true, snapshots, true));
      }
      if (!isCalledAsCallback) {
        if (this.props.isAuthenticated) {
          modal.add(TakeSnapshotModal, {
            size: 'snapshot',
            hideTitleBar: true,
            hideCloseButton: true,
            currentItem,
            currentTimestamp: timestamp,
            onSnapshotError: this.onSnapshotFailure,
            onSnapshotReshoot: this.takeSnapshot,
          });
        } else {
          modal.add(LoginModalView, { title: '', size: 'medium', hideTitleBar: true });
        }
      }
    }
  }

  openPartner() {
    modal.clear();
    modal.add(PartnerModalView, { title: '', size: 'medium', hideTitleBar: true });
  }

  openSocial() {
    modal.clear();
    modal.add(SocialModalView, { title: '', size: 'medium', hideTitleBar: true });
  }

  openDownloadApp() {
    modal.clear();
    modal.add(DownloadAppModalView, { title: '', size: 'medium', hideTitleBar: true });
  }

  openPopModal(e, type) {
    e.preventDefault();
    const { currentItem } = this.props;

    // Disabling popup info about popouts. Clean up the view and components at some point.
    // if (!Cookie.get(`showed_pop_${type}`)) {
    //   modal.clear();
    //   modal.add(PopModalView, { title: '', size: 'medium', hideTitleBar: true, type });
    //   return;
    // }

    if (type === 'livecam') {
      modal.clear();
      const newWindow = window.open(`/livecams/player/${currentItem.camgroup_slug}/${currentItem.slug}`,
        `${this.props.slug}-player`,
        'status=0,toolbar=0,directories=0,menubar=0,resizable=0,scrollbars=0,width=942px,height=530px',
      );
      if (window.focus) newWindow.focus();
      return;
    }

    if (type === 'comments') {
      modal.clear();
      const height = window.innerHeight;
      const newWindow = window.open(`/livecams/disqus/${currentItem.camgroup_slug}/${currentItem.slug}`,
        `${this.props.slug}-disqus`,
        `status=0,toolbar=0,directories=0,menubar=0,resizable=0,scrollbars=1,width=942px,height=${height}px`,
      );
      if (window.focus) newWindow.focus();
    }
  }

  onToggleInfoOverlay(e, type) {
    e.preventDefault();

    if (this.state.showInfoOverlay) {
      // If the overlay is open
      if (type === this.state.infoOverlayType) {
        // If the type being sent is the same as already open, close the infoOverlay
        this.setState({
          showInfoOverlay: false,
          infoOverlayType: '',
        });
      } else {
        // Change the info panel if it is already open
        this.setState({
          infoOverlayType: type,
        });
      }
    } else {
      this.setState({
        showInfoOverlay: true,
        infoOverlayType: type,
      });
    }
  }

  refresh() {
    this.setState({ key: new Date().getTime() });
  }

  onToggleCarousel() {
    if (this.state.showVideoCarousel) {
      this.setState({ showVideoCarousel: false });
      $(this.toggleButton)
        .html('<div>Show Other Cams</div>');
      $(this.toggleButton)
        .addClass('inactive');
    } else {
      $(this.toggleButton)
        .html('<div>Hide Other Cams</div>');
      $(this.toggleButton)
        .removeClass('inactive');
      this.setState({ showVideoCarousel: true });
    }
  }

  postComment() {
    const disqusId = this.props.currentItem.disqus_id;
    const comment = this.refs.commentInput.value;

    if (comment.length === 0) return;

    const commentInput = this.refs.commentInput;
    commentInput.value = '';
    this.setState({ submittingComment: true });

    if (!this.props.isAuthenticated) {
      commentInput.value = comment;
      this.setState({ submittingComment: false });
      modal.add(LoginModalView, { title: '', size: 'medium', hideTitleBar: true });
      return;
    }

    fetch(`${SERVER_URL}/submit_comment`, {
      method: 'post',
      credentials: 'include',
      headers: {
        Accept: 'application/json, text/javascript, */*; q=0.01',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: $.param({
        comment,
        disqus_id: disqusId,
      }),
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(() => {
        commentInput.value = '';
        $('#leave-comment .form-control')
          .attr('placeholder', 'COMMENT POSTED!');
        setTimeout(() => {
          $('#leave-comment .form-control')
            .attr('placeholder', 'Join the discussion...');
        }, 3000);
        $(this.refs.commentPosted)
          .removeClass('is-hidden');
        this.setState({ submittingComment: false });
      })
      .catch((error) => {
        console.error(error);
        commentInput.value = comment;
        this.setState({ submittingComment: false });
      });
  }

  closeAlert(ref) {
    const $alertToClose = $(this.refs[ref]);
    if ($alertToClose) {
      $alertToClose.addClass('is-hidden');
    }
  }

  // @TODO check if this is even used.
  onComingSoon(e) {
    if (e) e.preventDefault();
    modal.add(ComingSoonModal, { title: '', size: 'medium', hideTitleBar: true });
  }

  handleKeyPress(e) {
    if (e.key === 'Enter') {
      this.postComment(e);
    }
  }

  scrollToVideo() {
    const scrollTopPx = $('.video-player')
      .offset().top - $('.header-wrapper')
      .height() - 5;

    animateScroll.scrollTo(scrollTopPx, {
      smooth: true,
    });
  }

  snapshotIsEnabled() {
    const { currentItem, snapshotsEnabledGlobally } = this.props;
    const { hlsStream } = this.state;
    let isMeditation = currentItem.is_meditation;
    let isOffline = currentItem.is_offline;
    if (hlsStream && hlsStream.id === parseInt(currentItem.stream_id, 10)) {
      const { state } = hlsStream;
      if (state === 'live') {
        isOffline = false;
      } else {
        isOffline = true;
      }
      if (state === 'on_demand' && currentItem.offline_label === 'Meditation') {
        isMeditation = true;
      }
    }
    if (currentItem.force_offline) {
      isOffline = true;
    }
    const snapshotsEnabled = snapshotsEnabledGlobally && (currentItem.snapshot_enabled || isMeditation);
    return ((isOffline && !isMeditation) ? false : snapshotsEnabled);
  }

  isCameraLive() {
    const { currentItem } = this.props;
    const { hlsStream } = this.state;
    if (currentItem.force_offline) return false;
    if (hlsStream && hlsStream.id === parseInt(currentItem.stream_id, 10)) {
      const { state } = hlsStream;
      if (state === 'live') {
        return true;
      }
    }
    return false;
  }

  onSnapshotFailure() {
    this.setState({ snapshotFailure: true });
  }

  render() {
    const {
      currentItem,
      isAuthenticated,
      snapshotsEnabledGlobally,
      showRelatedSnapshots,
      canBroadcast,
      currentCamGroup,
      nonPrimaryFeeds,
    } = this.props;
    const { contests } = currentItem;
    let hasContest = false;
    if (contests) {
      hasContest = _.some(contests, (contest) => {
        return moment().isBefore(moment(contest.end_date));
      });
    }

    const snapshotsToggle = this.snapshotIsEnabled() ? '' : ' offline';

    // #ccc If the snapshot system has failed or if there are no snapshots yet.
    const snapshotButtonColor = this.state.snapshots.size > 0 && !this.state.snapshotFailure ? '#000' : '#ccc';

    const isActive = (this.isCameraLive()) ? 'live' : '';
    const controlsClass = 'justify-content-between';
    const isSnapshotMode = true;
    const isFacts = currentItem.facts && Object.keys(currentItem.facts).length > 0;

    let title = currentItem.h1_title ? currentItem.h1_title : currentItem.title;
    let location = currentItem.location_text;

    const isMultiLivecam = currentCamGroup.multi_livecam;

    if (isMultiLivecam) {
      title = currentCamGroup.title;
      location = currentCamGroup.location_text;
    }

    const boardButtons = Array.from(document.querySelectorAll('button[name="board-button"]')).map(button => ({
      id: button.id,
      text: button.textContent.replace('Comments', ''),
    }));

    return (
      <div className="bg-fff-50 video-player container-rounded mb-20">
        <div className={`video-heading container-top-rounded textColor-333 bg-fff-80 ${snapshotsToggle}`}>
          <div className="row">
            <div
              className={currentItem.is_offline || !snapshotsEnabledGlobally ? 'col pr-0' : 'col'}
              id="text-headings-left"
            >
              <div id="cam-category" className={`cam-category ${isActive}`}>
                <div className="cam-group-banner d-inline-block position-relative">
                  <div className="d-inline-block camera-title-block p-2">
                    <span
                      id="cam-title"
                      className="u-textSize-18 u-font-foundation-roman textColor-fff text-uppercase"
                    >
                      {isMultiLivecam ? 'Currently Live' : currentItem.cam_group.title}
                    </span>
                  </div>
                  <div className="align-items-center h-100 justify-content-center live-badge p-2 position-absolute px-4">
                    <span className="u-textSize-18">LIVE</span>
                  </div>
                </div>
              </div>

              <div id="cam-name" className="cam-name">
                <h1>
                  <span
                    id="cam-group-title"
                    className="cam-group-title u-font-foundation-roman d-block textColor-000"
                  >
                    {title}
                  </span>
                </h1>
                <span
                  id="cam-location"
                  className="cam-location d-block textColor-333 u-font-foundation-light"
                >
                  {location}
                </span>

                {hasContest &&
                  <div className="alert alert-success small-alert mt-2">
                    <i className="fa fa-trophy mr-2" /> Snapshot Contest
                  </div>
                }
              </div>
            </div>

            {!isMultiLivecam &&
            <div className="col-auto" style={{ position: 'relative' }}>
              <div
                data-tip
                data-for="take-snapshot"
                style={{ borderColor: snapshotButtonColor }}
                id="snapshot"
                className={`snapshot ${snapshotsToggle}`}
                ref="snapshot"
                onClick={() => {
                  this.state.snapshots.size > 0 && !this.state.snapshotFailure ? this.takeSnapshot() : this.noop();
                }}
                data-recordings-template={currentItem.recordings_template}
              >
                <i className="icon-SnapshotCamera" style={{ color: snapshotButtonColor }} />
              </div>
              {!isMobile.any &&
                <ReactTooltip
                  id="take-snapshot"
                  className="text-center take-snapshot-tooltip"
                  type="light"
                  effect="solid"
                  place="top"
                  multiline
                  offset={{ right: 10 }}
                >
                  Take Snapshot<br />(ctrl+alt+s)
                </ReactTooltip>
              }
            </div>
            }

            {isMultiLivecam ?
              <div className="col hidden-mobile" id="text-headings-right">
                <div className="float-right">
                  <div
                    className="d-flex justify-content-start flex-wrap"
                    style={{ maxWidth: '250px', rowGap: '13px' }}
                  >
                    {boardButtons.map((item) => {
                      return (
                        <div key={item.id}>
                          <TrackedButton
                            action="Go to board"
                            title={item.text}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              const boardButton = document.getElementById(item.id);
                              if (boardButton) {
                                boardButton.click();
                                boardButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
                              }
                            }}
                            className="video-player-btn fixed-width-btn d-inline-block text-center u-font-foundation-roman text-uppercase"
                            style={{ width: 'auto' }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              :
              <div className="col hidden-mobile" id="text-headings-right">
                <div className="float-right">
                  <div className="d-flex justify-content-start">
                    <div>
                      <TrackedButton
                        onClick={e => this.openPartner(e)}
                        className="video-player-btn fixed-width-btn d-inline-block text-center u-font-foundation-roman text-uppercase"
                        title="Partners"
                        action="Open partner modal"
                      />
                    </div>
                    <div>
                      <TrackedButton
                        action={`/snapshots/${currentItem.slug}/`}
                        title="Gallery"
                        to={`/snapshots/${currentItem.slug}/`}
                        type="link"
                        className="video-player-btn fixed-width-btn d-inline-block text-center u-font-foundation-roman text-uppercase"
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-start mT-10">
                    <div>
                      <TrackedButton
                        title="Social"
                        action="Open social modal"
                        onClick={e => this.openSocial(e)}
                        className="video-player-btn fixed-width-btn d-inline-block text-center u-font-foundation-roman text-uppercase"
                      />
                    </div>
                    <div>
                      <TrackedButton
                        title="App"
                        action="Open App download modal"
                        className="video-player-btn fixed-width-btn download-btn d-inline-block text-center u-font-foundation-roman text-uppercase"
                        onClick={e => this.openDownloadApp(e)}
                        gaAction="Click on 'Download App'"
                      >
                        <span><i className="fas fa-cloud-download-alt" /> app</span>
                      </TrackedButton>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

        {isMultiLivecam ? (
          <div className="video-player-wrap">
            <AlertsView />
            <div className="video-player-multi-screen">
              <div className="video-player-screen embed-responsive embed-responsive-16by9">
                <VideoScreen
                  url={currentItem.large_feed_html}
                  videoId={currentItem.video_id}
                  isFetching={!currentItem.id || this.props.isFetching}
                  refresh={this.state.key}
                />
              </div>
              {nonPrimaryFeeds.map((feed) => {
                return (
                  <div className="video-player-screen embed-responsive embed-responsive-16by9" key={`feed-${feed.id}`}>
                    <VideoScreen
                      url={feed.large_feed_html}
                      videoId={feed.video_id}
                      isFetching={this.props.isFetching}
                      refresh={this.state.key}
                    />
                  </div>
                );
              })}
            </div>
            <div className="refresh-wrap text-right">
              <RefreshButton refresh={this.refresh} />
            </div>
          </div>
        ) : (
          <div className="video-player-wrap">
            <AlertsView />
            <div className="video-player-screen embed-responsive embed-responsive-16by9">
              <div className="alerts-wrapper u-font-foundation-roman">
                <PlayerAlert />
                <div className="comment-alert is-hidden" ref="commentPosted">
                  <span className="alert-message">SUCCESS! YOUR COMMENT HAS BEEN POSTED</span>
                  <a className="alert-action" href="#disqus-drag">View Comments</a>
                  <span className="close-button" onClick={e => this.closeAlert('commentPosted', e)}>
                    <i className="icon-X_Close_Square" />
                  </span>
                </div>
                <div className="comment-alert is-hidden error" ref="unauthorized">
                  <span className="alert-message">YOU MUST BE LOGGED IN TO COMMENT</span>
                  <span className="close-button" onClick={e => this.closeAlert('unauthorized', e)}>
                    <i className="icon-X_Close_Square" />
                  </span>
                </div>
              </div>
              <VideoScreen
                url={currentItem.large_feed_html}
                videoId={currentItem.video_id}
                isFetching={!currentItem.id || this.props.isFetching}
                refresh={this.state.key}
              />
            </div>
            <div className="refresh-wrap text-right">
              <RefreshButton refresh={this.refresh} />
            </div>
          </div>
          )}

        {!isMultiLivecam &&
          <div className="video-controls bg-fff-80 container-bottom-rounded">
            <div className="row">
              <div className="col">
                {this.state.showInfoOverlay &&
                  <div className="info-overlay">
                    <InfoPanelView type={this.state.infoOverlayType} key={this.state.infoOverlayType} />
                  </div>
                }

                <ul className={`carousel-buttons d-flex ${controlsClass} row no-gutters`}>
                  <li className="col-auto d-flex mr-auto">
                    <FavoriteButton
                      isAuthenticated={isAuthenticated}
                      itemId={currentItem.id}
                      feedTitle={currentItem.title}
                      buttonType="video-player-btn d-inline-block text-btn u-font-foundation-roman text-uppercase"
                    />
                    {currentItem.weather_enabled &&
                      <div className="">
                        <TrackedButton
                          className="video-player-btn text-btn text-uppercase weather-btn d-none d-lg-block"
                          onClick={e => this.onToggleInfoOverlay(e, 'weather')}
                          title="Weather"
                          action="Click on Weather button"
                        />
                      </div>
                    }
                    {isFacts &&
                      <div className="">
                        <TrackedButton
                          className="video-player-btn text-btn text-uppercase weather-btn d-none d-lg-block"
                          onClick={e => this.onToggleInfoOverlay(e, 'facts')}
                          title="Facts"
                          action="Click on Facts button"
                        />
                      </div>
                    }
                    <div className="">
                      <TrackedButton
                        className="video-player-btn text-btn text-uppercase weather-btn d-none d-lg-block"
                        onClick={e => this.onToggleInfoOverlay(e, 'calendar')}
                        title="Calendar"
                        action="Click on Calendar button"
                      >
                        <i className="icon-Calendar_Cutout" />
                      </TrackedButton>
                    </div>
                  </li>
                  <li className="align-items-center d-flex hide-cams-toggle">
                    {showRelatedSnapshots ? this.hideOtherCams() : this.showOtherCams()}
                  </li>
                  <li className="col-auto d-flex ml-auto">
                    <div className="pop-out-btn">
                      <PopoutVideoManager group={currentItem.camgroup_slug} slug={currentItem.slug} title={currentItem.title} />
                    </div>
                    <div className="pop-out-btn">
                      <PopoutCommentsManager group={currentItem.camgroup_slug} slug={currentItem.slug} title={currentItem.title} newCommentSystem={currentItem.newCommentSystem} />
                    </div>
                  </li>
                </ul>
                {isAuthenticated && canBroadcast && (
                  <div className="text-center p-3">
                    <div className="pb-2 textColor-333 font-weight-bold d-none">
                      <hr className="mb-2 mt-1" />
                      Admin Tools
                      <hr className="mb-2 mt-1" />
                    </div>
                    <div>
                      <BroadcastToFacebookButton />
                      <SendPlayerAlertButton />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        }

        {!isMultiLivecam &&
          <RelatedSnapshotsCarousel
            camGroupId={currentItem.cam_group.id}
            userCamgroup={currentItem.user}
            toggleCarousel={showRelatedSnapshots}
            isSnapshotMode={isSnapshotMode}
          />
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { showRelatedSnapshots, commentsFullWidth, viewMode } = state.uiPreferences;
  const { data: userData } = state.currentUser;

  return {
    isFetching: state.currentItem.isFetching,
    currentItem: state.currentItem.data,
    nonPrimaryFeeds: state.currentItem.nonPrimaryFeeds,
    currentCamGroup: state.currentItem.data.cam_group,
    isAuthenticated: state.auth.isAuthenticated,
    userId: state.auth.userId,
    favorites: state.favorites.user,
    userName: state.auth.userName,
    isMounted: state.relatedSnapshots.mounted,
    snapshotsEnabledGlobally: state.globalConfig.snapshotsEnabled,
    cameraToken: state.auth.cameraToken,
    showRelatedSnapshots,
    commentsFullWidth,
    viewMode,
    canBroadcast: userData ? userData.canBroadcast : false,
    isLive: state.currentItem.data.isLive,
  };
};

VideoPlayer.propTypes = {
  currentItem: PropTypes.object,
  nonPrimaryFeeds: PropTypes.array,
  currentCamGroup: PropTypes.object,
  isFetching: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  snapshotsEnabledGlobally: PropTypes.bool,
  showRelatedSnapshots: PropTypes.bool,
  slug: PropTypes.string,
  userId: PropTypes.string,
  viewMode: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  canBroadcast: PropTypes.bool,
};

VideoPlayer.defaultProps = {
  camToggleText: 'Hide Other Cams',
  snapshotsEnabledGlobally: false,
  showRelatedSnapshots: false,
  currentItem: {
    title: 'Live Bald Eagle Cam',
    is_offline: false,
    location_text: 'Decorah, Iowa, USA',
    embed_url: 'https://www.youtube.com/embed/t2q89jtvEq8?rel=0&showinfo=0&autoplay=1',
  },
  nonPrimaryFeeds: [],
  isFetching: true,
  isAuthenticated: false,
  currentCamGroup: {
    title: 'Bald Eagles',
    id: 11,
  },
  slug: '',
  userId: '',
  canBroadcast: false,
};

export default connect(mapStateToProps)(VideoPlayer);
